import { Component, OnInit } from '@angular/core';
import { AppConstants, JsonHelper } from '../util/index';
import { Logger } from '../services/logger.service';
import { CacheService } from '../services/cache.service';
import { HttpService } from '../services/http.service';
import { NotificationService } from '../services/notification.service';
import { RangeNDC, Premium, RangeFilter, ResponseJson} from '../models/index';
import { FilterService } from '../filter/filter-service';
import { ActionName } from 'app/shared/constants';
import { AuditService } from 'app/services/audit.service';
import { SortMeta } from 'primeng/api';
import { FilterList, MobileIdDataDownloader } from './mobileid-data.downloader';
import { Table } from 'primeng/table';
//import { TablePageEvent } from 'primeng/table';

@Component({
  selector: 'app-mobileid-data',
  templateUrl: './mobileid-data.component.html',
  styleUrls: ['./mobileid-data.component.scss'],
  standalone: false
})
export class MobileidDataComponent extends FilterService implements OnInit {
  isDownloading = false;
  showFilterBy = true;
  iprnCols: any[];
  rangeCols: any[];
  tableCols: any[] = [];
  filterFieldCols: any[] = [];
  dataTotalCount: number;
  saveEvent: any;
  searchPattern: string;
  multiSortMeta: SortMeta[]; 

  lastQueryId = 0;
  lastResponseId = 0;
  saveTs: number;


  

  constructor(public log: Logger, public httpService: HttpService,
    public cacheService: CacheService, public notifService: NotificationService, public auditService: AuditService) {
    super(log, httpService, cacheService, notifService,);

    this.iprnCols = [
      { field: 'prime',       header: 'Prime',   width: '50px' },
      { field: 'primeMinus1', header: 'Prime-1', width: '50px' },
      { field: 'primeMinus2', header: 'Prime-2', width: '50px' },
      { field: 'primeMinus3', header: 'Prime-3', width: '40px' },
      { field: 'primeMinus4', header: 'Prime-4', width: '40px' },
      { field: 'code', header: 'Code', width: '30px' },
      { field: 'ndc', header: 'NDC', width: '30px' },
      { field: 'iso2', header: 'ISO2', width: '30px' },
      { field: 'termCountry', header: 'Country', width: '50px' },
      { field: 'tos', header: 'TOS', width: '30px' },
      { field: 'tosdesc', header: 'TOS Description', width: '75px' },
      { field: 'supplement', header: 'Supplement', width: '100px' },
      { field: 'provider', header: 'Provider', width: '75px' },
      { field: 'lemin', header: 'LEMin', width: '62px' },
      { field: 'lemax', header: 'LEMax', width: '64px' },
      // { field: 'lastUpdate', header: 'Last Observed', width: '80px' }
      { field: 'firstSeen', header: 'First Seen', width: '50px' },
      { field: 'lastSeen',  header: 'Last Seen',  width: '50px' }
    ];

    this.rangeCols = [
      { field: 'code', header: 'Code', width: '30px' },
      { field: 'ndc', header: 'NDC', width: '30px' },
      { field: 'iso2', header: 'ISO2', width: '30px' },
      { field: 'termCountry', header: 'Country', width: '50px' },
      { field: 'tos', header: 'TOS', width: '30px' },
      { field: 'tosdesc', header: 'TOS Description', width: '75px' },
      { field: 'supplement', header: 'Supplement', width: '100px' },
      { field: 'provider', header: 'Provider', width: '75px' },
      { field: 'lemin', header: 'LEMin', width: '62px' },
      { field: 'lemax', header: 'LEMax', width: '64px' },
      { field: 'effectiveDate', header: 'Effective Date', width: '75px' },
    ];

    this.tableCols = [...this.rangeCols];
    this.tableCols.forEach(c => {
      this.filterFieldCols.push(c.field);
    });
  }

  ngOnInit() {
    super.init();
    this.rangeFilter = new RangeFilter();
    this.loadDataDetails({ first:0, rows: 10, multiSortMeta:[],  globalFilter: ''});
  }

  applyFilter(dt: Table) {
    dt.reset();
    this.loadDataDetails({...this.saveEvent, first: 1});
  }

  clearAllMid(dt:Table){
    this.clearAll();
    dt.reset();
  }

  downloadRangeData() {
    let data = this.getExportColumnNames().join(AppConstants.DELIMITER) + '\n';
    let action = ActionName.NumberingDataRangeDownloadFltr;
    this.filteredRangeDataList.forEach(item => {
      let myItem, str;
      if (this.dataSource === 'IPRN') {
        myItem = item as Premium;
        str = Premium.toString(myItem, AppConstants.DELIMITER)
        action = ActionName.NumberingDataIPRNDownloadFltr
      } else {
        myItem = item as RangeNDC;
        str = RangeNDC.toString(myItem, AppConstants.DELIMITER);
      }
      data += str + '\n';
    });

    this.downloadFile([data], this.makeDownloadFilename(this.getFileName(), '.csv'));
    if (!this.hasFilterMid()) {
      this.createRangeFilter();
    }
    this.auditService.auditLog(action, this.rangeFilter)
  }

  downloadMobileIdFile() {
    this.isDownloading = true;
    this.httpService.getStream(AppConstants.DownloadMobileIdDataURL + this.dataSource, this.downloadFileHandler);
    return false;
  }

  downloadFileHandler = (data: Response) => {
    this.isDownloading = false;
    const fileName = this.dataSource + '_' + this.cacheService.lastMobileDateSetDate + '.csv';
    this.downloadFile(data.body, fileName, 'application/octet-stream');
  }

  toggleTableCols() {
    if (this.dataSource == 'IPRN') {
      this.tableCols = [...this.iprnCols];
    } else {
      this.tableCols = [...this.rangeCols];
    }
    this.tableCols.forEach(c => {
      this.filterFieldCols.push(c.field);
    });
  }



  async toggleDataSource(event: any) {
    if (event.currentTarget.checked) {
      this.dataSource = 'IPRN';
    } else {
      this.dataSource = 'Range';
      this.rangeFilter.numOfDaysSinceLastSeen = '';
    }
    this.loadDataDetails({...this.saveEvent, first:0, multiSortMeta:[]});
  }


  loadDataDetails(event) {

    if ( JSON.stringify(this.saveEvent) === JSON.stringify(event)  &&  (Date.now() - this.saveTs) < 1000   ) 
        return;
  

    const { first, rows, multiSortMeta,  globalFilter } = event;

    console.log("+++ loadDataDetails:", Date(), event, multiSortMeta, rows);
   
    const pageNo = first / rows;
    // this.pageNo = pageNo;
    // this.limit = rows;
    this.multiSortMeta = multiSortMeta;
    this.searchPattern = globalFilter;
    this.saveEvent = event;
    this.saveTs = Date.now();

    this.pagination(pageNo, rows, multiSortMeta, globalFilter,  () => {});
  }



  // FP pagination
  pagination(page, limit, sortMeta: SortMeta[], globalFilter, func) {
    this.filteredRangeDataList = [];
    this.dataTotalCount = undefined;


    let orderBy = sortMeta ? sortMeta.map(s => { return { property: s.field, dir: s.order == 1 ? 'ASC' : 'DESC' } }) : null;
    // , 
    const pageParams = {
      page: page,
      size: limit,
      orderBy: orderBy
    }


    const filterParams: FilterList = this.makeFilter(globalFilter);

    const body = {
      filter: filterParams,
      page: pageParams,
      lastQueryId: ++this.lastQueryId
    }



    if (this.dataSource == 'IPRN') {
      this.tableCols = [...this.iprnCols];
      this.httpService.post(JSON.stringify(body), AppConstants.QueryFilteredPremiumPageURL,
        [this.postQueryDataHandler]);
    } else {
      this.httpService.post(JSON.stringify(body), AppConstants.QueryFilteredRangePageURL,
        [this.postQueryDataHandler]);
    }
  }


  makeFilter(globalFilter:string): FilterList{
    return {
      iso2list: this.rangeFilter.iso2List,
      tosList: this.rangeFilter.tosDescList,
      providerList: this.rangeFilter.providerList.map(p => p.provider),
      // numOfMonthFromCurrentMonth:  this.rangeFilter.numOfMonthsSinceLastObserved ? this.rangeFilter.numOfMonthsSinceLastObserved : '0', 
      numOfDaysSinceLastSeen:  this.rangeFilter.numOfDaysSinceLastSeen ? this.rangeFilter.numOfDaysSinceLastSeen : '0', 
      searchPattern: globalFilter,
      primeType: null
    }
  }



  postQueryDataHandler = async(responseJson: ResponseJson) => {
    console.info('in postQueryDataHandler 1', Date());

    if (responseJson.status != AppConstants.SUCCESS){
      console.error("response error:", responseJson.message);
    }

    if (responseJson.lastQueryId != this.lastQueryId){
      console.warn("We ignore earlier response", responseJson.lastQueryId, " != ", this.lastQueryId);
      return;
    }
    else{
      this.lastResponseId = responseJson.lastQueryId;
    }

  
    if (responseJson.status === AppConstants.SUCCESS) {
      if (!responseJson.data) {
        console.warn('in postQueryDataHandler', Date(), responseJson.message, 'no-data');
        return;
      }

      const result: any = JsonHelper.parseArray(responseJson.data, Object );
      this.dataTotalCount=responseJson.totalCount;
      this.filteredRangeDataList = result;
      console.info('in postQueryDataHandler 2', Date(), this.filteredRangeDataList.length);
    }
  }

  // FP
  totalMessage(): string {
    let actual = this.dataTotalCount;
    
    return (this.hasFilterMid() ? "Filtered Records: " : "Total Records: ") + actual;

  };

hasFilterMid(): boolean {
  return this.hasFilter() || !!this.searchPattern;
}


  isLoading(): boolean{
    return this.lastQueryId != this.lastResponseId;
  }

 downloader: MobileIdDataDownloader;

 onDownload(){
    if (this.downloader  && this.downloader.isLoading())
      return;

    let filename = this.makeDownloadFilename(this.getFileName(), '.csv');

    const filterList: FilterList = this.makeFilter(this.saveEvent?.globalFilter);
 
    this.downloader = new MobileIdDataDownloader(
      filename,
      this.dataSource, 
      filterList,
      this.multiSortMeta,
      // 100000,
      this.httpService,
      // data
      this.dataTotalCount * 100  //expected file size (approximate)
      );   

      this.downloader.start();
  }


}

